<template>
	<ul class="v5-scrollnum"
		:style="{'width': getSize(wrapLength),
			'height': getSize(curHeight),
			'fontSize': getSize(size)}">
		<li class="v5-scrollnum-item"
			v-for="(item, index) in nums"
			:key="index"
			:style="{'left': getSize(curWidth * index),
				transform: 'translate3d(0,' + getSize(-item * curHeight) + ', 0)'}">
			<span class="v5-scrollnum-ten"
				v-for="n in 10"
				:key="n"
				:style="{'width': getSize(curWidth),
					'height': getSize(curHeight),
					'lineHeight': getSize(curHeight)}">
				{{ n - 1 }}
			</span>
		</li>
	</ul>
</template>

<script>
/**
 * 数字滚动组件
 */
export default {
	name: 'v5-scrollnum',
	props: {
		num: {
			type: [Number, String],
			required: true
		},
		width: {
			type: Number,
			default: 0
		},
		height: {
			type: Number,
			default: 0
		},
		size: {
			type: Number,
			default: 40
		},
		unitSize: {
			type: Number,
			default: 75
		}
	},
	data() {
		return {
			nums: [] // 数字拆分后的数组
		};
	},
	watch: {
		num(val) {
			this.nums = `${val}`.split('');
		}
	},
	created() {
		this.nums = new Array(`${this.num}`.length).fill(0);
		setTimeout(() => {
			this.nums = `${this.num}`.split('');
		}, 60);
	},
	methods: {
        /**
         * 单位换算：px 转 rem
         */
		getSize(n) {
			return `${n / this.unitSize}rem`;
		}
	},
	computed: {
		curWidth() {
			return this.width
				? this.width
				: Math.floor(this.size / 2);
		},
		curHeight() {
			return this.height ? this.height : this.size + 10;
		},
		wrapLength() {
			return this.nums.length * this.curWidth;
		}
	}
};
</script>

<style lang="scss">
@import './style.scss';
</style>
